import { Component, OnInit } from '@angular/core';
import '../services/rxjs-operators';

@Component({
  template: `<div class="wrapper"><div class="container"><router-outlet></router-outlet></div></div>`,
})
export class FrontendComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/frontend/frontend.component.ts